<style>
    /*
   * Die &Uuml;berschriften sollen ohne Kapitelnummerierung dargestellt werden.
   * Eine automatische Nummerierung aus globalen CSS-Regeln wird deshalb verhindert.
   */
    .ktbl-help h2,
    .ktbl-help h3,
    .ktbl-help h4 {
        counter-increment: none !important;
    }

    .ktbl-help h2::before,
    .ktbl-help h3::before,
    .ktbl-help h4::before {
        content: none !important;
        display: none !important;
    }

    .ktbl-help [id] {
        scroll-margin-top: 6rem;
    }

    .ktbl-help-toc {
        margin: 1.5rem 0 2rem;
    }

    .ktbl-help-toc ul {
        margin: 0.35rem 0;
        padding-left: 1.5rem;
    }

    .ktbl-help-toc>ul {
        padding-left: 1.25rem;
    }

    .ktbl-help-toc li {
        margin: 0.3rem 0;
    }

    .ktbl-help-toc a {
        white-space: normal !important;
        overflow-wrap: anywhere;
    }

    /* Keine Aufz&auml;hlungszeichen im Inhaltsverzeichnis */
    .ktbl-help .ktbl-help-toc ul,
    .ktbl-help .ktbl-help-toc ol,
    .ktbl-help .ktbl-help-toc li {
        list-style: none !important;
    }

    .ktbl-help .ktbl-help-toc>ul {
        margin-left: 0 !important;
        padding-left: 0 !important;
    }

    .ktbl-help .ktbl-help-toc ul ul {
        margin-left: 0 !important;
        padding-left: 1.5rem !important;
    }

    .ktbl-help .ktbl-help-toc li::marker {
        content: "" !important;
        font-size: 0 !important;
    }

    .ktbl-help .ktbl-help-toc li::before {
        content: none !important;
        display: none !important;
    }
</style>
<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-container">
    <article class="ktbl-help">
        <h1>Erläuterungen der Fachbegriffe in BauKost</h1>

        <h2 id="inhaltsverzeichnis">
            Inhaltsverzeichnis
        </h2>

        <nav aria-labelledby="inhaltsverzeichnis" class="ktbl-help-toc">
            <ul>
                <li>
                    <a href="begriffserlaeuterungen-baukost#abschreibung">
                        Abschreibung
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#aussenanlagen-und-freiflaechen-kg-500">
                        Au&szlig;enanlagen und Freifl&auml;chen (KG 500)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#baukonstruktive-einbauten-kg-380">
                        Baukonstruktive Einbauten (KG 380)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#baunebenkosten-kg-700">
                        Baunebenkosten (KG 700)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#baupreisindex-2021-100">
                        Baupreisindex (2021 = 100)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#bauwerk-baukonstruktionen-kg-300">
                        Bauwerk &ndash; Baukonstruktionen (KG 300)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#bauwerk-technische-anlagen-kg-400">
                        Bauwerk &ndash; Technische Anlagen (KG 400)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#bewirtschaftung-funktionsbereich-und-kostenblock">
                        Bewirtschaftung &ndash; Funktionsbereich und Kostenblock
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#din-276-kosten-im-bauwesen">
                        DIN 276 &ndash; Kosten im Bauwesen
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#din-277-grundflaechen-und-rauminhalte-im-bauwesen">
                        DIN 277 &ndash; Grundfl&auml;chen und Rauminhalte im Bauwesen
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#funktionsflaechen">
                        Funktionsfl&auml;chen
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#fuetterung-funktionsbereich-und-kostenblock">
                        F&uuml;tterung &ndash; Funktionsbereich und Kostenblock
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#gebaeudegrobelemente">
                        Geb&auml;udegrobelemente
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#grundstueck-kg-100">
                        Grundst&uuml;ck (KG 100)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#investitionsbedarf">
                        Investitionsbedarf
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#jaehrliche-gebaeudekosten">
                        J&auml;hrliche Geb&auml;udekosten
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#kennung">
                        Kennung
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#kostenbloecke">
                        Kostenbl&ouml;cke
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#kostenelemente">
                        Kostenelemente
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#mehrwertsteuer">
                        Mehrwertsteuer
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#nutzungsdauer-bei-investitionen">
                        Nutzungsdauer bei Investitionen
                    </a>
                </li>

                <li>
                    <a
                        href="begriffserlaeuterungen-baukost#nutzungsspezifische-und-verfahrenstechnische-anlagen-kg-470">
                        Nutzungsspezifische und verfahrenstechnische Anlagen (KG 470)
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#planungskennzahlen">
                        Planungskennzahlen
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#preisfaktor">
                        Preisfaktor
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#preisstand">
                        Preisstand
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#tier-funktionsbereich-und-kostenblock">
                        Tier &ndash; Funktionsbereich und Kostenblock
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#tierproduktgewinnung-funktionsbereich-und-kostenblock">
                        Tierproduktgewinnung &ndash; Funktionsbereich und Kostenblock
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#unterhaltung">
                        Unterhaltung
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#versicherung">
                        Versicherung
                    </a>
                </li>

                <li>
                    <a href="begriffserlaeuterungen-baukost#zinskosten">
                        Zinskosten
                    </a>
                </li>
            </ul>
        </nav>

        <h2 id="abschreibung">
            Abschreibung
        </h2>

        <p>
            In BauKost wird eine lineare Abschreibung ohne Restwert und ohne Abbruchkosten
            unterstellt. Die Abschreibung der Kostenelemente (KE) wird differenziert nach
            den Nutzungsdauern von 30 Jahren = langfristig, 15 Jahren = mittelfristig und
            10 Jahren = kurzfristig berechnet.
        </p>

        <p>
            jährliche Abschreibung =
            Σ (KE langfristig / 30) +
            Σ (KE mittelfristig / 15) +
            Σ (KE kurzfristig / 10)
        </p>


        <h2 id="aussenanlagen-und-freiflaechen-kg-500">
            Außenanlagen und Freiflächen (KG 500)
        </h2>

        <p>
            Kostengruppe 500 nach DIN 276 für die Außenbereiche eines Bauwerks.
        </p>

        <p>
            In BauKost werden die Kosten dieser Gruppe teilweise berücksichtigt, z. B.
            Treibwege, Verladerampen oder Kraftfuttersilos.
        </p>


        <h2 id="baukonstruktive-einbauten-kg-380">
            Baukonstruktive Einbauten (KG 380)
        </h2>

        <p>
            Kostengruppe 380 nach DIN 276 für fest mit dem Bauwerk verbundene Einbauten jedoch ohne die
            nutzungsspezifischen Anlagen in Kostengruppe
            470 -
            Nutzungsspezifische Anlagen. Baukonstruktive Einbauten in der Landwirtschaft
            sind perforierte Böden, Stand- und Liegeflächen, Aufstallung, Krippenschalen,
            Tröge, Jaucherinnen, Gülleleitungen, Gülleabsperrungen.
        </p>


        <h2 id="baunebenkosten-kg-700">
            Baunebenkosten (KG 700)
        </h2>

        <p>
            Kostengruppe 700 nach DIN 276 für Planung, Genehmigungen und weitere
            Nebenkosten eines Bauprojekts.
        </p>

        <p>
            Die Baunebenkosten sind im ausgewiesenen Investitionsbedarf von BauKost nicht
            enthalten und können hilfsweise mit etwa 5–10 % des Investitionsbedarfs
            angesetzt werden.
        </p>

        <h2 id="baupreisindex-2021-100">
            Baupreisindex (2021 = 100)
        </h2>

        <p>
            Der Baupreisindex stellt dar, wie sich der Kostenaufwand für die Errichtung
            oder Instandhaltung von Gebäuden und baulichen Anlagen in Bezug auf ein vom
            Statistischen Bundesamt festgelegten Basisjahr entwickelt hat.
        </p>

        <p>
            Die Ställe und baulichen Anlagen in BauKost werden auf der Grundlage des
            aktuellen Baupreisindex des Statistischen Bundesamtes mit einem einheitlichen
            Preisstand berechnet.
        </p>

        <p>
            Preisindizes für den Neubau gewerblicher Betriebsgebäude ohne Umsatzsteuer
            (2021 = 100, Quelle: Statistisches Bundesamt)
        </p>

        <table mat-table [dataSource]="preisstandDataSource" class="ktbl-table-breite-komplett">

            <ng-container *ngFor="let column of preisstandDisplayedCols; let j = index" [matColumnDef]="column">

                <th mat-header-cell *matHeaderCellDef [ngClass]="{
            'ktbl-table-header-base-links': j === 0,
            'ktbl-table-header-base-rechts': j === (preisstandDisplayedCols.length - 1),
            'ktbl-table-header-typografie': true,
            'ktbl-table-allgemein-300-width': j === 0
        }">
                    <ng-container *ngIf="column === 'jahr'">Jahr</ng-container>
                    <ng-container *ngIf="column === 'wert'">Indizes in %</ng-container>
                </th>

                <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,
            'ktbl-table-cell-left': column === 'jahr' || column === 'wert',
            'ktbl-links-ausgerichtet-padding': column === 'wert'
        }">
                    <ng-container *ngIf="column === 'jahr'">{{ entry.preisstand }}</ng-container>
                    <ng-container *ngIf="column === 'wert'">{{ entry.wert | number:'1.1-1':'de-DE' }}</ng-container>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="preisstandDisplayedCols"></tr>
            <tr mat-row *matRowDef="let row; columns: preisstandDisplayedCols"></tr>

        </table>

        <p></p>


        <h2 id="bauwerk-baukonstruktionen-kg-300">
            Bauwerk – Baukonstruktionen (KG 300)
        </h2>

        <p>
            Kostengruppe 300 nach DIN 276 für die konstruktiven Bestandteile eines
            Gebäudes wie Gründung, Wände, Decken und Dach.
        </p>


        <h2 id="bauwerk-technische-anlagen-kg-400">
            Bauwerk – Technische Anlagen (KG 400)
        </h2>

        <p>
            Kostengruppe 400 nach DIN 276 für technische Einrichtungen wie Wasser-,
            Wärme-, Lüftungs- und Elektroanlagen.
        </p>


        <h2 id="bewirtschaftung-funktionsbereich-und-kostenblock">
            Bewirtschaftung – Funktionsbereich und Kostenblock
        </h2>

        <p>
            Dem Funktionsbereich und funktionsbezogenen Kostenblock „Bewirtschaftung“
            sind alle Flächen und Einrichtungen zugeordnet, die vorwiegend von Menschen
            genutzt werden. Hierzu gehören beispielsweise Stallgänge, Büros und
            Sozialräume.
        </p>


        <h2 id="din-276-kosten-im-bauwesen">
            DIN 276 – Kosten im Bauwesen
        </h2>

        <p>
            Die DIN 276 gliedert Baukosten nach Planungs- und Ausführungsbereichen.
            Sie dient der planungsorientierten Strukturierung von Baukosten in
            Kostengruppen.
        </p>

        <p>
            Erste Gliederungsebene:
        </p>

        <table mat-table [dataSource]="gliederungsebeneDataSource" class="ktbl-table-breite-komplett">

            <ng-container *ngFor="let column of gliederungsebeneDisplayedCols; let j = index" [matColumnDef]="column">

                <th mat-header-cell *matHeaderCellDef [ngClass]="{
            'ktbl-table-header-base-links': j === 0,
            'ktbl-table-header-base-rechts': j === (gliederungsebeneDisplayedCols.length - 1),
            'ktbl-table-header-typografie': true,
            'ktbl-table-allgemein-300-width': j === 0
        }">
                    <ng-container *ngIf="column === 'kostengruppe'">Kostengruppe</ng-container>
                    <ng-container *ngIf="column === 'bezeichnung'">Beschreibung</ng-container>
                </th>

                <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,
            'ktbl-table-cell-left': column === 'kostengruppe' || column === 'bezeichnung',
            'ktbl-links-ausgerichtet-padding': column === 'bezeichnung'
        }">
                    <ng-container *ngIf="column === 'kostengruppe'">{{ entry.kostengruppe }}</ng-container>
                    <ng-container *ngIf="column === 'bezeichnung'">{{ entry.bezeichnung }}</ng-container>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="gliederungsebeneDisplayedCols"></tr>
            <tr mat-row *matRowDef="let row; columns: gliederungsebeneDisplayedCols"></tr>

        </table>
        <p>

        </p>

        <p>BauKost enthält Daten und Kosten zu den Kostengruppen 300 bis 500.</p>
        <p>Für Baunebenkosten können zusätzlich etwa 5–10 % des Investitionsbedarfs angesetzt werden.</p>
        <p>Zweite Gliederungsebene (Gebäudegrobelemente):</p>

        <table mat-table [dataSource]="kostengruppeDataSource" class="ktbl-table-breite-komplett">

            <ng-container *ngFor="let column of kostengruppeDisplayedCols; let j = index" [matColumnDef]="column">

                <th mat-header-cell *matHeaderCellDef [ngClass]="{
            'ktbl-table-header-base-links': j === 0,
            'ktbl-table-header-base-rechts': j === (kostengruppeDisplayedCols.length - 1),
            'ktbl-table-header-typografie': true,
            'ktbl-table-allgemein-300-width': j === 0
        }">
                    <ng-container *ngIf="column === 'kostengruppe'">Kostengruppe</ng-container>
                    <ng-container *ngIf="column === 'bezeichnung'">Bezeichnung</ng-container>
                </th>

                <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,
            'ktbl-table-cell-left': column === 'kostengruppe' || column === 'bezeichnung',
            'ktbl-links-ausgerichtet-padding': column === 'bezeichnung'
        }">

                    <ng-container *ngIf="column === 'kostengruppe'">{{ entry.kostengruppe }}</ng-container>
                    <ng-container *ngIf="column === 'bezeichnung'">{{ entry.bezeichnung }}</ng-container>
                </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="kostengruppeDisplayedCols"></tr>
            <tr mat-row *matRowDef="let row; columns: kostengruppeDisplayedCols"></tr>

        </table>

        <p></p>


        <h3>Beispiele landwirtschaftlicher Einbauten
        </h3>

        <p>
            KG 380 – Baukonstruktive Einbauten
        </p>

        <ul>
            <li>perforierte Böden</li>
            <li>Liegeflächen</li>
            <li>Krippenschalen</li>
            <li>Tröge</li>
            <li>Gülleleitungen</li>
            <li>Gülleabsperrungen</li>
        </ul>

        <p>
            KG 470 – Nutzungsspezifische Anlagen
        </p>

        <ul>
            <li>Liegeboxenabtrennungen</li>
            <li>Futterbehälter</li>
            <li>Raufen</li>
            <li>Tränken</li>
            <li>Fütterungsanlagen</li>
            <li>Mistschieber</li>
            <li>Melktechnik</li>
            <li>Milchkühlung</li>
            <li>Eiersortieranlagen</li>
        </ul>

        <p>
            KG 540 – Baukonstruktionen in Außenanlagen
        </p>

        <ul>
            <li>Unterstände</li>
            <li>Futtersilos</li>
            <li>Hochsilos</li>
            <li>Flachsilos</li>
            <li>Güllebehälter</li>
            <li>Mistplatten</li>
        </ul>

        <h2 id="din-277-grundflaechen-und-rauminhalte-im-bauwesen">
            DIN 277 – Grundflächen und Rauminhalte im Bauwesen
        </h2>

        <p>
            Die DIN 277 ist eine Normenreihe zur einheitlichen Definition, Berechnung und
            Gliederung von Grundflächen und Rauminhalten von Bauwerken im Hochbau.
        </p>


        <h2 id="funktionsflaechen">
            Funktionsflächen
        </h2>

        <p>
            In BauKost werden die Funktionsflächen als Brutto- und Nettoflächen angegeben.
            Die Bruttoflächen beinhalten zusätzlich zu den Nettoflächen die jeweilige,
            anteilige Konstruktionsgrundfläche (= Summe der Grundflächen der aufgehenden
            Bauteile, z. B. Wände, Stützen, Pfeiler). Es werden vier verschiedene Arten
            von Funktionsflächen unterschieden:
        </p>

        <table mat-table [dataSource]="flaecheDataSource" class="ktbl-table-breite-komplett">

            <ng-container *ngFor="let column of flaecheDisplayedCols; let j = index" [matColumnDef]="column">

                <th mat-header-cell *matHeaderCellDef [ngClass]="{
            'ktbl-table-header-base-links': j === 0,
            'ktbl-table-header-base-rechts': j === (flaecheDisplayedCols.length - 1),
            'ktbl-table-header-typografie': true,
            'ktbl-table-allgemein-300-width': j === 0
        }">
                    <ng-container *ngIf="column === 'flaeche'">Fläche</ng-container>
                    <ng-container *ngIf="column === 'beschreibung'">Beschreibung</ng-container>
                </th>

                <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,
            'ktbl-table-cell-left': column === 'flaeche' || column === 'beschreibung',
            'ktbl-links-ausgerichtet-padding': column === 'beschreibung'
        }">
                    <ng-container *ngIf="column === 'flaeche'">{{ entry.flaeche }}</ng-container>

                    <ng-container *ngIf="column === 'beschreibung'">{{ entry.beschreibung }}</ng-container>
                </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="flaecheDisplayedCols"></tr>
            <tr mat-row *matRowDef="let row; columns: flaecheDisplayedCols"></tr>

        </table>
        <p></p>
        <h2 id="fuetterung-funktionsbereich-und-kostenblock">
            Fütterung - Funktionsbereich und Kostenblock
        </h2>

        <p>
            Dem Funktionsbereich und funktionsbezogenen Kostenblock „Fütterung“ sind alle
            Flächen und Einrichtungen zugeordnet, die für die Futterlagerung,
            Futteraufbereitung und Futtervorlage dienen. Beispiele hierfür sind
            Futtertröge, Futtertisch und die Futterküche.
        </p>


        <h2 id="gebaeudegrobelemente">
            Gebäudegrobelemente
        </h2>

        <p>
            Die zweite Gliederungsebene der DIN 276 wird mithilfe von
            Gebäudegrobelemente strukturiert. Sie umfassen konstruktive und technische
            Hauptbestandteile eines Gebäudes, beispielsweise Gründung, Außenwände, Dächer
            oder technische Anlagen, die als Kostenpositionen dienen.
        </p>


        <h2 id="grundstueck-kg-100">
            Grundstück (KG 100)
        </h2>

        <p>
            Kostengruppe 100 der DIN 276 für den Erwerb oder die Bereitstellung eines
            Grundstücks. Die Kosten der Kostengruppe 100 sind in BauKost nicht enthalten.
        </p>


        <h2 id="investitionsbedarf">
            Investitionsbedarf
        </h2>

        <p>
            Der Investitionsbedarf beschreibt die Kosten für die Errichtung eines neuen
            Gebäudes durch ein Bauunternehmen.
        </p>

        <p>
            Ermittelt wird der Investitionsbedarf nach den in der DIN 276 „Kosten im
            Bauwesen“ angegebenen Kostengruppen. In BauKost werden folgende
            Kostengruppenberücksichtigt:
        </p>

        <ul>
            <li>300 Bauwerk - Baukonstruktionen</li>
            <li>400 Bauwerk - Technische Anlagen</li>
            <li>
                teilweise 500 - Außenanlagen und Freiflächen
                (z. B. Triebwege, Kraftfuttersilos, Verladerampen)
            </li>
        </ul>

        <p>
            Für das Baugrundstück werden gute Bedingungen, z. B. für Bauuntergrund und
            Hangneigung, unterstellt. Zusätzliche Kosten für Erdarbeiten, Gründung oder
            Grundwassersicherung können standortbedingt erheblich abweichen.
        </p>

        <p>
            Bei Stallgebäuden sind im Investitionsbedarf enthalten:
        </p>

        <ul>
            <li>Melktechnik</li>
            <li>Lüftungstechnik</li>
            <li>Fütterungstechnik</li>
            <li>Entmistungstechnik</li>
        </ul>

        <p>
            Nicht enthalten sind:
        </p>

        <ul>
            <li>Grundstückskosten</li>
            <li>Erschließungskosten</li>
            <li>Planungs- und Genehmigungskosten</li>
            <li>regionale Preisunterschiede</li>
            <li>Grobfutterlager</li>
            <li>Außenlager für Wirtschaftsdünger</li>
        </ul>


        <h2 id="jaehrliche-gebaeudekosten">
            Jährliche Gebäudekosten
        </h2>

        <p>
            Die jährlichen Gebäudekosten beschreiben die durchschnittlichen Kosten eines
            Gebäudes pro Jahr während seiner Nutzungsdauer.
        </p>

        <p>
            In BauKost setzen sich die jährlichen Gebäudekosten zusammen aus der Summe
            von:
        </p>

        <ul>
            <li>Abschreibung</li>
            <li>Zinskosten</li>
            <li>Unterhaltungskosten</li>
            <li>Versicherungskosten</li>
        </ul>

        <p>
            Die jährlichen Gebäudekosten werden in BauKost sowohl als Gesamtsumme als
            auch bezogen auf Kennzahlen als Bezugseinheiten (z. B. je Tierplatz)
            ausgewiesen.
        </p>


        <h2 id="kennung">
            Kennung
        </h2>

        <p>
            Jedes Bauwerk verfügt über eine individuelle Kennung und kann so zweifelsfrei
            identifiziert werden. Die Kennung besteht aus auf die bauliche Anlage
            bezogenen Buchstaben, z. B. „MS“ für Mastschwein, und einer dreistelligen
            Ziffernfolge.
        </p>


        <h2 id="kostenbloecke">
            Kostenblöcke
        </h2>

        <p>
            Kostenblöcke sind funktionsbezogene Gebäudebereiche.
        </p>


        <table mat-table [dataSource]="kostenblockDataSource" class="ktbl-table-breite-komplett">

            <ng-container *ngFor="let column of kostenblockDisplayedCols; let j = index" [matColumnDef]="column">

                <th mat-header-cell *matHeaderCellDef [ngClass]="{
                    'ktbl-table-allgemein-300-width': j === 0,
            'ktbl-table-header-base-links': j === 0,
            'ktbl-table-header-base-rechts': j === (kostenblockDisplayedCols.length - 1),
            'ktbl-table-header-typografie': true
            
        }">
                    <ng-container *ngIf="column === 'kostenblock'">Kostenblock</ng-container>
                    <ng-container *ngIf="column === 'beschreibung'">Zugeordnete Konstruktionen und
                        Anlagen</ng-container>
                </th>

                <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,
            'ktbl-table-cell-left': column === 'kostenblock' || column === 'beschreibung',
            'ktbl-links-ausgerichtet-padding': column === 'beschreibung'
        }">
                    <ng-container *ngIf="column === 'kostenblock'"> ({{ entry.kostenblock }}) </ng-container>
                    <ng-container *ngIf="column === 'beschreibung'">({{ entry.beschreibung }})</ng-container>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="kostenblockDisplayedCols"></tr>
            <tr mat-row *matRowDef="let row; columns: kostenblockDisplayedCols"></tr>

        </table>
        <p></p>
        <h2 id="kostenelemente">
            Kostenelemente
        </h2>

        <p>
            Kostenelemente untergliedern den Investitionsbedarf entsprechend den
            Gebäudegrobelementen der DIN 276, die in BauKost für Auswertungen und
            Vergleiche verwendet werden.
        </p>


        <h2 id="mehrwertsteuer">
            Mehrwertsteuer
        </h2>

        <p>
            In BauKost wird die gesetzliche Mehrwertsteuer standardmäßig nicht
            berücksichtigt. Sie kann über einen Preisfaktor zusätzlich in die Kosten
            eingerechnet werden.
        </p>


        <h2 id="nutzungsdauer-bei-investitionen">
            Nutzungsdauer bei Investitionen
        </h2>

        <p>
            Zur Berechnung der jährlichen Gebäudekosten in BauKost werden alle Bauteile
            drei verschiedenen Nutzungsdauern zugeordnet:
        </p>

        <p>
            Langfristige Investitionen - 30 Jahre (Beispiele)
        </p>

        <ul>
            <li>Baugrube</li>
            <li>Gründung</li>
            <li>Außen- und Innenwände</li>
            <li>Decken</li>
            <li>Dächer</li>
            <li>Stau- und Sammelkanäle</li>
            <li>Wirtschaftsdüngerlager</li>
        </ul>

        <p>
            Mittelfristige Investitionen - 15 Jahre (Beispiele)
        </p>

        <ul>
            <li>Betonspaltenböden</li>
            <li>Krippen</li>
            <li>Starkstromanlagen</li>
            <li>Ver- und Entsorgungsanlagen</li>
            <li>folienausgekleidete Erdbecken</li>
        </ul>

        <p>
            Kurzfristige Investitionen - 10 Jahre (Beispiele)
        </p>

        <ul>
            <li>Buchtenabtrennungen</li>
            <li>Fressgitter</li>
            <li>Futterautomaten</li>
            <li>Futterwagen</li>
            <li>Abruffütterung</li>
            <li>Armaturen und Sperrschieber</li>
        </ul>


        <h2 id="nutzungsspezifische-und-verfahrenstechnische-anlagen-kg-470">
            Nutzungsspezifische und verfahrenstechnische Anlagen (KG 470)
        </h2>

        <p>
            Kostengruppe 470 nach DIN 276 für alle mit dem Bauwerk fest verbundenen
            Anlagen, die der besonderen Zweckbestimmung eines Gebäudes dienen, jedoch
            ohne die baukonstruktiven Einbauten der Kostengruppe 380.
        </p>

        <p>
            Nutzungsspezifische Anlagen in der Landwirtschaft sind beispielsweise:
            Trennwände für Buchten, Abtrennungen für Liegeboxen, Aufstallung,
            Futterbehälter, Raufen, Förder- und Verteilanlagen, Tränken, Mahl- und
            Mischanlagen, Fütterungsanlagen, Mistschieber mit Antrieb, Güllerühr- und
            -entnahmegeräte nur im Stall, Melkeinrichtung, Milchlagerung und -kühlung,
            Eiersortier- und -verpackungsanlagen
        </p>


        <h2 id="planungskennzahlen">
            Planungskennzahlen
        </h2>

        <p>
            Zur Beurteilung der Baukosten stellt BauKost je nach Gebäudeart oder Art der
            baulichen Anlage verschiedene Planungskennzahlen pro Bezugseinheit bereit:
        </p>

        <ol>
            <li>Tierplatz</li>
            <li>Nutzungsdauer</li>
            <li>Fläche</li>
            <li>Volumen</li>
            <li>Jahr</li>
            <li>Kostenelemente</li>
            <li>Kostenblöcke</li>
        </ol>

        <p>
            Die Grundflächen und Rauminhalte werden nach DIN 277 "Grundflächen und
            Rauminhalte von Bauwerken im Hochbau" berechnet.
        </p>


        <h2 id="preisfaktor">
            Preisfaktor
        </h2>

        <p>
            Unter dem Reiter „Einstellungen“ kann der Preisfaktor in BauKost individuell
            eingestellt werden. Der Preisfaktor und dient zur Anpassung der berechneten
            Kosten an die regionalen Verhältnisse, zur Anpassung an zukünftige
            Preisentwicklungen oder die Berücksichtigung der Mehrwertsteuer.
        </p>


        <h2 id="preisstand">
            Preisstand
        </h2>

        <p>
            In BauKost ist der Preisstand unter dem Reiter „Einstellungen“ ein individuell auf verschiedene Jahreszahlen
            einstellbarer, prozentualer Umrechnungsfaktor. Dadurch können die in BauKost dargestellten Kosten auch auf
            frühere Jahre umgerechnet werden.
        </p>


        <h2 id="tier-funktionsbereich-und-kostenblock">
            Tier – Funktionsbereich und Kostenblock
        </h2>

        <p>
            Dem Funktionsbereich und funktionsbezogenen Kostenblock „Tier“ sind alle
            Flächen und Einrichtungen zugeordnet, die unmittelbar von den Tieren genutzten
            werden. Hierzu gehören beispielsweise Liegebuchten und Laufhöfe.
        </p>


        <h2 id="tierproduktgewinnung-funktionsbereich-und-kostenblock">
            Tierproduktgewinnung – Funktionsbereich und Kostenblock
        </h2>

        <p>
            Dem Funktionsbereich und funktionsbezogenen Kostenblock
            „Tierproduktgewinnung“ werden alle Flächen Einrichtungen zugeordnet, die
            unmittelbar der Gewinnung, Lagerung und Behandlung von Tierprodukten wie
            Milch oder Eiern dienen. Beispiele sind der Melkstand einschließlich
            Wartehof, die Milchlagerung und der Eiersortierraum.
        </p>


        <h2 id="unterhaltung">
            Unterhaltung
        </h2>

        <p>
            Die Kosten für die Unterhaltung von Ställen und baulichen Anlagen resultieren
            aus Reparaturen, Instandhaltungs- und Pflegemaßnahmen. In BauKost wird mit
            pauschalen Prozentsätzen vom Investitionsbedarf der Kostenelemente (KE)
            gerechnet, die jährlich zu Buche schlagen. Der Aufwand ist für die drei
            Kategorien lang-, mittel- und kurzfristig nutzbare Bauteile unterschiedlich
            festgelegt, und zwar mit:
        </p>

        <ul>
            <li>1 % für langfristige Bauteile,</li>
            <li>2 % für mittelfristige Bauteile und</li>
            <li>3 % für kurzfristige Bauteile.</li>
        </ul>

        <p>
            Unterhaltung =
            Σ (KE langfristig × 0,01) +
            Σ (KE mittelfristig × 0,02) +
            Σ (KE kurzfristig × 0,03)
        </p>


        <h2 id="versicherung">
            Versicherung
        </h2>

        <p>
            Die Kosten für die Gebäudeversicherung bei Ställen und baulichen Anlagen
            entstehen unabhängig von der Auslastung je Jahr und zählen damit zu den
            fixen Kosten. Die Versicherungskosten werden in BauKost mit 0,2 % des
            Investitionsbedarfs berechnet:
        </p>

        <p>
            Versicherung = Investitionsbedarf × 0,002
        </p>


        <h2 id="zinskosten">
            Zinskosten
        </h2>

        <p>
            Die Zinskosten entsprechen den gezahlten Zinsen für gebundenes Fremdkapital
            oder dem kalkulatorischen Zinsansatz für gebundenes Eigenkapital. Bei der
            Berechnung der Zinskosten wird von einem während der Nutzungsdauer
            durchschnittlich zu verzinsendem Anlagewert von 50 % des
            Investitionsbedarfs ausgegangen. Die Zinskosten sind somit das Produkt aus
            dem halben Investitionsbedarf und dem Zinssatz. Aktuell wird ein
            einheitlicher Zinssatz von 3 % unterstellt.
        </p>

        <p>
            Zinsen = (Investitionsbedarf / 2) × 0,03
        </p>
    </article>
</div>


<div class="ktbl-spacer-top-bottom"></div>



<div class="ktbl-floating-container-ohne-rand-wrapper">
    <div class="ktbl-floating-content">
        <button (click)="onClickUp()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button="" type="button">
            <i class="fas fa-chevron-up ktbl-icon-vertical-align">
            </i>
        </button>
        <button (click)="onClickDown()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button=""
            type="button">
            <i class="fas fa-chevron-down ktbl-icon-vertical-align">
            </i>
        </button>
    </div>
</div>